import { render, staticRenderFns } from "./fpzLiabilityAdd.vue?vue&type=template&id=bfb9b406"
import script from "./fpzLiabilityAdd.vue?vue&type=script&lang=js"
export * from "./fpzLiabilityAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports